import type { FC } from "react";
import { Icon } from "@ospweb/sdk-ui";
import { cn } from "utils";
import { OnboardingCtaButton } from "../shared/OnboardingCtaButton";

interface QuizChoiceOptionProps {
  optionId: string;
  label: string;
  selected?: boolean;
  onSelect: () => void;
}

export const QuizChoiceOption: FC<QuizChoiceOptionProps> = ({
  optionId,
  label,
  selected,
  onSelect,
}) => (
  <button
    type="button"
    data-testid="quiz-choice-option"
    data-option-id={optionId}
    data-selected={selected ? "true" : "false"}
    className={cn(
      "flex w-full items-center justify-between rounded-xl p-[18px] transition-colors",
      selected ? "bg-content_aura_lv3_primary" : "bg-white/10",
    )}
    onClick={onSelect}
  >
    <span
      data-testid="quiz-choice-option-label"
      className={cn(
        "body_medium_l",
        selected
          ? "text-content_brand_primary"
          : "text-content_inverse_primary",
      )}
    >
      {label}
    </span>
    <span
      className={cn(
        "flex size-6 items-center justify-center rounded-xl",
        selected
          ? "bg-content_brand_primary"
          : "border-2 border-border_white_transparent50",
      )}
      data-testid="quiz-choice-option-indicator"
    >
      {selected ? (
        <Icon name="check" size={14} className="text-content_inverse_primary" />
      ) : null}
    </span>
  </button>
);

interface QuizContinueButtonProps {
  label?: string;
  disabled?: boolean;
  loading?: boolean;
  /** Dark quiz surface: enabled CTA is white per Figma UI4 */
  surface?: "dark" | "light";
  onClick: () => void;
}

export const QuizContinueButton: FC<QuizContinueButtonProps> = ({
  label,
  disabled,
  loading,
  surface = "dark",
  onClick,
}) => (
  <OnboardingCtaButton
    testId="quiz-continue-button"
    label={label}
    disabled={disabled}
    loading={loading}
    surface={surface}
    withFooter={false}
    onClick={onClick}
  />
);
